const surfacesAttrChangeObserver = (liveDocument) => {
  const {
    defaultView: { frameElement },
  } = liveDocument;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const newValue = mutation.target.getAttribute(mutation.attributeName);
      if (newValue !== mutation.oldValue) {
        mutation.target.dispatchEvent(
          new CustomEvent('ws:surfaceChange', {
            bubbles: true,
            detail: {
              surface: newValue,
            },
          })
        );
      }
    });
  });

  observer.observe(liveDocument.body, {
    attributeFilter: ['surfaces'],
    attributeOldValue: true,
    subtree: true,
  });

  frameElement.contentWindow.addEventListener(
    'unload',
    () => {
      observer.disconnect();
    },
    {
      once: true,
    }
  );
};

export default surfacesAttrChangeObserver;
